import {isValidEmail} from '~/lib/validation';
import React, {useState} from 'react';
import PropTypes from 'prop-types';

import FormTextInput from '../FormTextInput';

const EmailInput = ({label, value, style, onChange}) => {
  const [email, setEmail] = useState(value);
  const [emailError, setEmailError] = useState(false);

  return (
    <FormTextInput
      label={label}
      value={email}
      onChangeText={setEmail}
      onEndEditing={() => {
        const valid = isValidEmail(email);
        setEmailError(!valid);
        if (valid) {
          onChange(email);
        }
      }}
      style={style}
      hasError={emailError}
      errorMessage="Email heeft een ongeldige waarde"
      inputProps={{
        keyboardType: 'email-address',
      }}
    />
  );
};

EmailInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.any,
  onChange: PropTypes.func,
};

export default EmailInput;
